export enum uaePassDocStatus {

    NOT_REQUIRED = 'NOT_REQUIRED',
    PENDING = 'PENDING',
    SUBMITTED_UAEPASS = 'SUBMITTED_UAEPASS',
    SUBMITTED_NORMAL = 'SUBMITTED_NORMAL'
}
